import { render, staticRenderFns } from "./ActivityCategories.vue?vue&type=template&id=f12fc568&scoped=true&"
import script from "./ActivityCategories.vue?vue&type=script&lang=js&"
export * from "./ActivityCategories.vue?vue&type=script&lang=js&"
import style0 from "./ActivityCategories.vue?vue&type=style&index=0&id=f12fc568&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12fc568",
  null
  
)

export default component.exports